import React, { type ReactNode, createContext, useState } from "react";

import { type UserProfile } from "@/schemas/user/profile";
import { type ScreenConfig } from "@/schemas/screen/configs";

export type HeaderContext = {
  currentScreen: ScreenConfig;
  currentUserProfile: UserProfile | null;
  isUserBlocked: boolean;
  setIsUserBlocked: (isBlocked: boolean) => void;
  setCurrentUserProfile: (profile: UserProfile) => void;
  setCurrentScreen: (screen: ScreenConfig) => void;
  updateCurrentScreen: (updates: Partial<ScreenConfig>) => void;
};

export const HeaderContext = createContext<HeaderContext | null>(null);

type Props = {
  children: ReactNode;
  initialScreen: ScreenConfig;
};

export const HeaderContextProvider: React.FC<Props> = ({
  children,
  initialScreen,
}) => {
  const [currentScreen, setCurrentScreen] =
    useState<ScreenConfig>(initialScreen);
  const [currentUserProfile, setCurrentUserProfile] =
    useState<UserProfile | null>(null);
  const [isUserBlocked, setIsUserBlocked] = useState<boolean>(false);

  const updateCurrentScreen = (updates: Partial<ScreenConfig>): void => {
    setCurrentScreen(
      (prevScreen) =>
        ({
          ...prevScreen,
          ...updates,
        }) as ScreenConfig,
    );
  };

  return (
    <HeaderContext.Provider
      value={{
        currentScreen,
        currentUserProfile,
        isUserBlocked,
        setIsUserBlocked,
        setCurrentUserProfile,
        setCurrentScreen,
        updateCurrentScreen,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};
